import { CardOutlineIcon } from './CardOutlineIcon';

/**
 * author: Rynco Li
 * id EB9242D1-9D25-4141-A1A0-06636EC84541
 * name card-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-outline.svg
 * tags
 * - Form 
 */
export const ButtonOutlineIcon = CardOutlineIcon;
export default ButtonOutlineIcon